import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getAreaList = (params, options) =>
  request.get(
    '/api/blade-system/region/lazy-tree',
    Object.assign({}, options, { params })
  );

  export const nursingPage = (params, options) =>
  request.get(
    '/api/nursing/registration/page',
    Object.assign({}, options, { params })
  );

  
  export const nursingSave= (params, options) =>
  request.post('/api/nursing/save', params, options);
  export const nursingDetail = (params, options) =>
  request.get(
    '/api/nursing/detail',
    Object.assign({}, options, { params })
  );

  export const nursingUpdate= (params, options) =>
  request.post('/api/nursing/update', params, options);